export default "__VITE_ASSET__9651c674__"